module.exports = __webpack_public_path__ + "img/zaixianzhifu.ce3abc63.jpg";